import React from "react";
import styles from "./InTaxIncomeSummary.module.css";

export default function InTaxIncomeSummary({ ytd = {} }) {
  const fmt = new Intl.NumberFormat(undefined, { style: "currency", currency: "CAD" }).format;
  const items = [
    { k: "Gross", v: ytd.gross || 0 },
    { k: "Withheld", v: ytd.withheld || 0 },
    { k: "Other", v: ytd.other || 0 },
    { k: "Take-home", v: ytd.takeHome || 0 },
  ];

  return (
    <div className={`row g-3 ${styles.strip}`}>
      {items.map(({ k, v }) => (
        <div key={k} className="col-6 col-lg-3">
          <div className="border rounded-3 p-2 bg-body">
            <div className="small text-secondary">{k}</div>
            <div className="fw-semibold">{fmt(v)}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
